export const SET_MEDIAVIEWIER = "SET_MEDIAVIEWIER";
export const SET_SHOW_SMALL_VIEW_PORT = "SET_SHOW_SMALL_VIEW_PORT";
export const SET_SELECTED_MEDIA = "SET_SELECTED_MEDIA";
export const SET_SELECTED_INDEX = "SET_SELECTED_INDEX";
export const SET_DISPLAY = "SET_DISPLAY";
export const SET_PANO_FULL_SCREEN = "SET_PANO_FULL_SCREEN";
export const SET_SHOW_MEDIA_OBJ = "SET_SHOW_MEDIA_OBJ";
export const SET_ERROR_IDX = "SET_ERROR_IDX";
export const SET_MEDIA_PARAM = "SET_MEDIA_PARAM";

interface ActionTypes {
  SET_MEDIAVIEWIER: string | boolean;
  SET_SHOW_SMALL_VIEW_PORT: boolean;
  SET_SELECTED_MEDIA: any;
  SET_SELECTED_INDEX: number;
  SET_DISPLAY: boolean;
  SET_PANO_FULL_SCREEN: boolean;
  SET_SHOW_MEDIA_OBJ: boolean;
  SET_ERROR_IDX: Array<any>;
  SET_MEDIA_PARAM: string;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export function setShowMediaViewer(
  show: string | boolean
): MediaViewerActionTypes {
  return {
    type: SET_MEDIAVIEWIER,
    payload: show,
  };
}

export function setShowSmallViewPort(show: boolean): MediaViewerActionTypes {
  return {
    type: SET_SHOW_SMALL_VIEW_PORT,
    payload: show,
  };
}

export function setSelectedMedia(media: any): MediaViewerActionTypes {
  return {
    type: SET_SELECTED_MEDIA,
    payload: media,
  };
}

export function setSelectedIndex(index: number): MediaViewerActionTypes {
  return {
    type: SET_SELECTED_INDEX,
    payload: index,
  };
}

export function setDisplay(display: boolean): MediaViewerActionTypes {
  return {
    type: SET_DISPLAY,
    payload: display,
  };
}

export function setPanoFullScreen(show: boolean): MediaViewerActionTypes {
  return {
    type: SET_PANO_FULL_SCREEN,
    payload: show,
  };
}

export function setShowMediaObj(show: boolean): MediaViewerActionTypes {
  return {
    type: SET_SHOW_MEDIA_OBJ,
    payload: show,
  };
}

export function setErrorIdx(errorIdx: Array<any>): MediaViewerActionTypes {
  return {
    type: SET_ERROR_IDX,
    payload: errorIdx,
  };
}

export function setMediaParam(param: string): MediaViewerActionTypes {
  return {
    type: "SET_MEDIA_PARAM",
    payload: param,
  };
}

export type MediaViewerActionTypes = MessageAction;
